// RÉGI CÍM → ÁTIRÁNYÍTÁS. A katalógus a `/services` lap „Katalógus" füle lett; ez a route CSAK a korábbi
// linkeket tartja életben (⌘K-paletta szerkesztés-ugrása `?edit=`, könyvjelzők, doksi-hivatkozások).
//
// A search-paramok is átfordulnak `cat_*`-ra — a `/services` lapon két lista ül, ezért ott minden szűrő
// prefixes; enélkül a linkelt NÉZET veszne el, nem csak a lap.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { catalogRedirectSearch } from '@/features/services/legacy-redirect';

/** A RÉGI kulcs-készlet (változatlanul) — ezt fordítjuk `cat_*`-ra. */
const legacySearchSchema = z.object({
  edit: z.string().optional(),
  q: z.string().optional(),
  category: z.string().optional(),
  status: z.string().optional(),
  sort: z.string().optional(),
  order: z.string().optional(),
});

export const Route = createFileRoute('/service-catalog')({
  validateSearch: (search) => legacySearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/services', replace: true, search: catalogRedirectSearch(search) });
  },
});
